<template>
  <div id="app" :data-v="'v-1.1.0'">
    <component-fileviewer/>
    <component-modal v-if="store.modal.active"/>
    <component-banner/>

    <div class="mt40" v-if="getUserProfilIsLoading" :class="{ 'sk-loading': getUserProfilIsLoading}">
      <spinner-three-bounce :displayNone="!getUserProfilIsLoading"/>
    </div>
    <router-view v-if="!getUserProfilIsLoading"/>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import Banner from './components/Banner'
  import Fileviewer from './components/Fileviewer'
  import Modal from './components/Modal'
  import store from './config/store'
  import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'

  export default {
    components: {
      'component-banner': Banner,
      'component-fileviewer': Fileviewer,
      'component-modal': Modal,
      SpinnerThreeBounce
    },

    mounted () {},

    data: () => ({
      store,
      getUserProfilIsLoading: false,
      userInfos: {
        userProfil: null,
        userIsManager: false,
        managerId: "",
        userIsExpert: false,
        expertId: "",
        expert: null
      }
    }),

    watch: {
      isLoggedIn: function () {
        if(!store.data.userInfos){
          this.getUserProfil()
        }
      }
    },

    computed: {
      isLoggedIn () {
        return store.data.user
      },
      userProfilQuery () {
        return gql`
          query {
          userProfil
            {
            id
            type
            firstname
            lastname
            email
            }
          }`
      },
      expertiseCompanyWithExpertQuery () {
        return gql`
          query {
          expert(
            id: "${this.userInfos.expertId}"
            ) {
            id
            name
            address {
              address
              city
              zipCode
            }
            }
          }`
      }
    },

    methods: {
      saveUserInfosInStore () {
        store.data.userInfos = this.userInfos
        this.saveData()
      },
      importRenaultCss () {
        import('@/assets/renault/stylesheets/renault.css');
        import('@/assets/renault/stylesheets/fonts.css');
      },
      getUserProfil () {
        this.getUserProfilIsLoading = true

        this.$apollo.query({
          query: this.userProfilQuery,
          fetchPolicy: 'no-cache'
        }).then(response => {
          this.userInfos.userProfil = response.data.userProfil
          this.getUserProfilIsLoading = false
          if(this.userInfos.userProfil.type === "Expert"){
            this.userInfos.expertId = this.userInfos.userProfil.id
            this.userInfos.userIsExpert = true
          }
          this.saveUserInfosInStore()
          this.getExpertiseCompanyWithExpert()

        }, () => {
          this.showBanner('danger', "Désolé, le userProfil n'est pas disponible.")
          this.getUserProfilIsLoading = false
        })
      },
      getExpertiseCompanyWithExpert () {
        this.getUserProfilIsLoading = true

        this.$apollo.query({
          query: this.expertiseCompanyWithExpertQuery,
          fetchPolicy: 'no-cache'
        }).then(response => {
          this.userInfos.expert = response.data.expert[0]

          this.saveUserInfosInStore()
          this.getUserProfilIsLoading = false
        }, () => {
          this.showBanner('danger', "Désolé, la companie d'expertise n'est pas disponible.")
          this.getUserProfilIsLoading = false
        })    
      },
    }
  }
</script>


